/* eslint no-use-before-define: 0 */
import React from "react";
import { Box, TextField } from "@mui/material";
import { Field } from "formik";
import PropTypes from "prop-types";

const Textarea = (props) => {
  const { label, name, ...rest } = props;
  return (
    <Field as="input" id={name} name={name}>
      {({ field }) => (
        <Box data-testid='textarea'>
          <TextField
            id={name}
            label={label}
            multiline
            rows={3}
            {...rest}
            {...field}
          />
        </Box>
      )}
    </Field>
  );
};

export default Textarea;
Textarea.propTypes ={
  label: PropTypes.string, 
  name: PropTypes.string,
}